/** Wyszukuje po nazwie i wartościach wpisów obu typów słownika. */
export function filterDictionaryEntries(entries, search) {
  const query = search.trim().toLocaleLowerCase("pl");
  return entries.filter((entry) => {
    const values =
      typeof entry.value === "string"
        ? entry.value
        : Object.values(entry.value).join(" ");
    return `${entry.key} ${values}`.toLocaleLowerCase("pl").includes(query);
  });
}
